import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';

// Shared shell for the public pages Zoom's Marketplace links to
// (privacy, terms, support, user guide). No login needed.
export const COMPANY = 'Pro Advisor USA Inc.';
export const SUPPORT_EMAIL = 'noorieks007@gmail.com';
export const SUPPORT_PHONE = '+1 630-407-4338';
export const SUPPORT_HOURS = 'Monday to Friday, 9 am – 5 pm US Central Time (CST/CDT)';

const LINKS = [
  ['Privacy', '/privacy_policy'],
  ['Terms', '/terms'],
  ['Support', '/support'],
  ['User guide', '/guide'],
];

const PublicPage = ({ title, updated, icon, children }) => {
  React.useEffect(() => { document.title = title + ' · ZPro Audio'; }, [title]);
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', position: 'relative', color: 'text.primary' }}>
      <div className="aurora" />
      <div className="grid-veil" />

      <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, py: 2.5, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <Box component="img" src={process.env.PUBLIC_URL + '/zproaudio.png'} alt="" sx={{ width: 34, height: 34, borderRadius: 2 }} />
        <Typography variant="h6" sx={{ color: '#fff', letterSpacing: '0.04em' }}>ZPro Audio</Typography>
      </Box>

      <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'center', px: 2, py: { xs: 3, sm: 6 } }}>
        <Paper
          elevation={0}
          sx={{
            width: '100%', maxWidth: 820, p: { xs: 3, sm: 5 }, borderRadius: 4,
            background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)',
            backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)',
            '& h2': { color: 'text.primary', fontSize: '1.15rem', fontWeight: 700, marginTop: '2rem', marginBottom: '0.5rem' },
            '& h3': { color: 'text.primary', fontSize: '1rem', fontWeight: 700, marginTop: '1.25rem', marginBottom: '0.25rem' },
            '& p': { color: 'text.secondary', lineHeight: 1.7, marginBlock: '0.6rem' },
            '& li': { color: 'text.secondary', lineHeight: 1.7, marginBottom: '0.4rem' },
            '& strong': { color: 'text.primary' },
            '& a': { color: '#7dd3fc' },
            '& ul, & ol': { paddingLeft: '1.5rem' },
            '& ul': { listStyle: 'disc' },
            '& ol': { listStyle: 'decimal' },
            '& li::marker': { color: '#7dd3fc' },
            '& table': { width: '100%', borderCollapse: 'collapse', margin: '0.75rem 0' },
            '& th, & td': { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid rgba(255,255,255,0.1)', color: 'text.secondary', verticalAlign: 'top' },
            '& th': { color: 'text.primary', fontWeight: 600 },
          }}
        >
          <Stack alignItems="center" spacing={1} sx={{ mb: 3 }}>
            {icon}
            <Typography variant="h3" className="text-gradient" sx={{ fontWeight: 800, textAlign: 'center', fontSize: { xs: '1.8rem', sm: '2.4rem' } }}>{title}</Typography>
            {updated && <Typography variant="body2" color="text.secondary">Last updated {updated}</Typography>}
          </Stack>
          <div style={{ textAlign: 'start' }}>{children}</div>
        </Paper>
      </Box>

      <Box component="footer" sx={{ position: 'relative', zIndex: 1, textAlign: 'center', pb: 5, color: 'text.secondary', fontSize: 14 }}>
        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 1, flexWrap: 'wrap' }}>
          {LINKS.map(([label, href]) => (
            <Box key={href} component="a" href={href} sx={{ color: '#7dd3fc', textDecoration: 'none' }}>{label}</Box>
          ))}
        </Stack>
        © {new Date().getFullYear()} {COMPANY}
      </Box>
    </Box>
  );
};

export default PublicPage;
